import {
    DOCUMENT_CREATE_REQUEST,
    DOCUMENT_CREATE_SUCCESS,
    DOCUMENT_CREATE_ERROR,
    DOCUMENT_DOWNLOAD
} from './actionTypes';

export const documentCreateRequest = (type, groupId, metadata = {}) => ({
    type: DOCUMENT_CREATE_REQUEST,
    payload: {type, groupId, metadata}
});

export const documentCreateSuccess = (document) => ({
    type: DOCUMENT_CREATE_SUCCESS,
    payload: document
});

export const documentCreateError = (error) => ({
    type: DOCUMENT_CREATE_ERROR,
    payload: error
});

export const documentDownload = (id) => ({
    type: DOCUMENT_DOWNLOAD,
    payload: {id}
});
